const groupStageFixtures = [
  [1, "A", "Meksyk", "Republika Południowej Afryki", "2026-06-11T19:00:00.000Z", "Mexico City Stadium"],
  [2, "A", "Korea Południowa", "Czechy", "2026-06-12T02:00:00.000Z", "Estadio Guadalajara"],
  [3, "B", "Kanada", "Bośnia i Hercegowina", "2026-06-12T19:00:00.000Z", "Toronto Stadium"],
  [4, "D", "Stany Zjednoczone", "Paragwaj", "2026-06-13T01:00:00.000Z", "Los Angeles Stadium"],
  [5, "B", "Katar", "Szwajcaria", "2026-06-13T19:00:00.000Z", "San Francisco Bay Area Stadium"],
  [6, "C", "Brazylia", "Maroko", "2026-06-13T22:00:00.000Z", "New York New Jersey Stadium"],
  [7, "C", "Haiti", "Szkocja", "2026-06-14T01:00:00.000Z", "Boston Stadium"],
  [8, "D", "Australia", "Turcja", "2026-06-14T04:00:00.000Z", "BC Place Vancouver"],
  [9, "E", "Niemcy", "Curaçao", "2026-06-14T17:00:00.000Z", "Houston Stadium"],
  [10, "F", "Holandia", "Japonia", "2026-06-14T20:00:00.000Z", "Dallas Stadium"],
  [11, "E", "Wybrzeże Kości Słoniowej", "Ekwador", "2026-06-14T23:00:00.000Z", "Philadelphia Stadium"],
  [12, "F", "Szwecja", "Tunezja", "2026-06-15T02:00:00.000Z", "Estadio Monterrey"],
  [13, "H", "Hiszpania", "Republika Zielonego Przylądka", "2026-06-15T16:00:00.000Z", "Atlanta Stadium"],
  [14, "G", "Belgia", "Egipt", "2026-06-15T19:00:00.000Z", "Seattle Stadium"],
  [15, "H", "Arabia Saudyjska", "Urugwaj", "2026-06-15T22:00:00.000Z", "Miami Stadium"],
  [16, "G", "Iran", "Nowa Zelandia", "2026-06-16T01:00:00.000Z", "Los Angeles Stadium"],
  [17, "I", "Francja", "Senegal", "2026-06-16T19:00:00.000Z", "New York New Jersey Stadium"],
  [18, "I", "Irak", "Norwegia", "2026-06-16T22:00:00.000Z", "Boston Stadium"],
  [19, "J", "Argentyna", "Algieria", "2026-06-17T01:00:00.000Z", "Kansas City Stadium"],
  [20, "J", "Austria", "Jordania", "2026-06-17T04:00:00.000Z", "San Francisco Bay Area Stadium"],
  [21, "K", "Portugalia", "Demokratyczna Republika Konga", "2026-06-17T17:00:00.000Z", "Houston Stadium"],
  [22, "L", "Anglia", "Chorwacja", "2026-06-17T20:00:00.000Z", "Dallas Stadium"],
  [23, "L", "Ghana", "Panama", "2026-06-17T23:00:00.000Z", "Toronto Stadium"],
  [24, "K", "Uzbekistan", "Kolumbia", "2026-06-18T02:00:00.000Z", "Mexico City Stadium"],
  [25, "A", "Czechy", "Republika Południowej Afryki", "2026-06-18T16:00:00.000Z", "Atlanta Stadium"],
  [26, "B", "Szwajcaria", "Bośnia i Hercegowina", "2026-06-18T19:00:00.000Z", "Los Angeles Stadium"],
  [27, "B", "Kanada", "Katar", "2026-06-18T22:00:00.000Z", "BC Place Vancouver"],
  [28, "A", "Meksyk", "Korea Południowa", "2026-06-19T01:00:00.000Z", "Estadio Guadalajara"],
  [29, "D", "Stany Zjednoczone", "Australia", "2026-06-19T19:00:00.000Z", "Seattle Stadium"],
  [30, "C", "Szkocja", "Maroko", "2026-06-19T22:00:00.000Z", "Boston Stadium"],
  [31, "C", "Brazylia", "Haiti", "2026-06-20T00:30:00.000Z", "Philadelphia Stadium"],
  [32, "D", "Turcja", "Paragwaj", "2026-06-20T03:00:00.000Z", "San Francisco Bay Area Stadium"],
  [33, "F", "Holandia", "Szwecja", "2026-06-20T17:00:00.000Z", "Houston Stadium"],
  [34, "E", "Niemcy", "Wybrzeże Kości Słoniowej", "2026-06-20T20:00:00.000Z", "Toronto Stadium"],
  [35, "E", "Ekwador", "Curaçao", "2026-06-21T00:00:00.000Z", "Kansas City Stadium"],
  [36, "F", "Tunezja", "Japonia", "2026-06-21T04:00:00.000Z", "Estadio Monterrey"],
  [37, "H", "Hiszpania", "Arabia Saudyjska", "2026-06-21T16:00:00.000Z", "Atlanta Stadium"],
  [38, "G", "Belgia", "Iran", "2026-06-21T19:00:00.000Z", "Los Angeles Stadium"],
  [39, "H", "Urugwaj", "Republika Zielonego Przylądka", "2026-06-21T22:00:00.000Z", "Miami Stadium"],
  [40, "G", "Nowa Zelandia", "Egipt", "2026-06-22T01:00:00.000Z", "BC Place Vancouver"],
  [41, "J", "Argentyna", "Austria", "2026-06-22T17:00:00.000Z", "Dallas Stadium"],
  [42, "I", "Francja", "Irak", "2026-06-22T21:00:00.000Z", "Philadelphia Stadium"],
  [43, "I", "Norwegia", "Senegal", "2026-06-23T00:00:00.000Z", "New York New Jersey Stadium"],
  [44, "J", "Jordania", "Algieria", "2026-06-23T03:00:00.000Z", "San Francisco Bay Area Stadium"],
  [45, "K", "Portugalia", "Uzbekistan", "2026-06-23T17:00:00.000Z", "Houston Stadium"],
  [46, "L", "Anglia", "Ghana", "2026-06-23T20:00:00.000Z", "Boston Stadium"],
  [47, "L", "Panama", "Chorwacja", "2026-06-23T23:00:00.000Z", "Toronto Stadium"],
  [48, "K", "Kolumbia", "Demokratyczna Republika Konga", "2026-06-24T02:00:00.000Z", "Estadio Guadalajara"],
  [49, "B", "Szwajcaria", "Kanada", "2026-06-24T19:00:00.000Z", "BC Place Vancouver"],
  [50, "B", "Bośnia i Hercegowina", "Katar", "2026-06-24T19:00:00.000Z", "Seattle Stadium"],
  [51, "C", "Szkocja", "Brazylia", "2026-06-24T22:00:00.000Z", "Miami Stadium"],
  [52, "C", "Maroko", "Haiti", "2026-06-24T22:00:00.000Z", "Atlanta Stadium"],
  [53, "A", "Czechy", "Meksyk", "2026-06-25T01:00:00.000Z", "Mexico City Stadium"],
  [54, "A", "Republika Południowej Afryki", "Korea Południowa", "2026-06-25T01:00:00.000Z", "Estadio Monterrey"],
  [55, "E", "Curaçao", "Wybrzeże Kości Słoniowej", "2026-06-25T20:00:00.000Z", "Philadelphia Stadium"],
  [56, "E", "Ekwador", "Niemcy", "2026-06-25T20:00:00.000Z", "New York New Jersey Stadium"],
  [57, "F", "Japonia", "Szwecja", "2026-06-25T23:00:00.000Z", "Dallas Stadium"],
  [58, "F", "Tunezja", "Holandia", "2026-06-25T23:00:00.000Z", "Kansas City Stadium"],
  [59, "D", "Turcja", "Stany Zjednoczone", "2026-06-26T02:00:00.000Z", "Los Angeles Stadium"],
  [60, "D", "Paragwaj", "Australia", "2026-06-26T02:00:00.000Z", "San Francisco Bay Area Stadium"],
  [61, "I", "Norwegia", "Francja", "2026-06-26T19:00:00.000Z", "Boston Stadium"],
  [62, "I", "Senegal", "Irak", "2026-06-26T19:00:00.000Z", "Toronto Stadium"],
  [63, "H", "Republika Zielonego Przylądka", "Arabia Saudyjska", "2026-06-27T00:00:00.000Z", "Houston Stadium"],
  [64, "H", "Urugwaj", "Hiszpania", "2026-06-27T00:00:00.000Z", "Estadio Guadalajara"],
  [65, "G", "Egipt", "Iran", "2026-06-27T03:00:00.000Z", "Seattle Stadium"],
  [66, "G", "Nowa Zelandia", "Belgia", "2026-06-27T03:00:00.000Z", "BC Place Vancouver"],
  [67, "L", "Panama", "Anglia", "2026-06-27T21:00:00.000Z", "New York New Jersey Stadium"],
  [68, "L", "Chorwacja", "Ghana", "2026-06-27T21:00:00.000Z", "Philadelphia Stadium"],
  [69, "K", "Kolumbia", "Portugalia", "2026-06-27T23:30:00.000Z", "Miami Stadium"],
  [70, "K", "Demokratyczna Republika Konga", "Uzbekistan", "2026-06-27T23:30:00.000Z", "Atlanta Stadium"],
  [71, "J", "Algieria", "Austria", "2026-06-28T02:00:00.000Z", "Kansas City Stadium"],
  [72, "J", "Jordania", "Argentyna", "2026-06-28T02:00:00.000Z", "Dallas Stadium"],
];

const knockoutFixtures = [
  [73, "round_of_32", "2. miejsce grupy A", "2. miejsce grupy B", "2026-06-28T19:00:00.000Z", "Los Angeles Stadium"],
  [74, "round_of_32", "1. miejsce grupy E", "3. miejsce z grup A/B/C/D/F", "2026-06-29T20:30:00.000Z", "Boston Stadium"],
  [75, "round_of_32", "1. miejsce grupy F", "2. miejsce grupy C", "2026-06-30T01:00:00.000Z", "Estadio Monterrey"],
  [76, "round_of_32", "1. miejsce grupy C", "2. miejsce grupy F", "2026-06-29T17:00:00.000Z", "Houston Stadium"],
  [77, "round_of_32", "1. miejsce grupy I", "3. miejsce z grup C/D/F/G/H", "2026-06-30T21:00:00.000Z", "New York New Jersey Stadium"],
  [78, "round_of_32", "2. miejsce grupy E", "2. miejsce grupy I", "2026-06-30T17:00:00.000Z", "Dallas Stadium"],
  [79, "round_of_32", "1. miejsce grupy A", "3. miejsce z grup C/E/F/H/I", "2026-07-01T01:00:00.000Z", "Mexico City Stadium"],
  [80, "round_of_32", "1. miejsce grupy L", "3. miejsce z grup E/H/I/J/K", "2026-07-01T16:00:00.000Z", "Atlanta Stadium"],
  [81, "round_of_32", "1. miejsce grupy D", "3. miejsce z grup B/E/F/I/J", "2026-07-02T00:00:00.000Z", "San Francisco Bay Area Stadium"],
  [82, "round_of_32", "1. miejsce grupy G", "3. miejsce z grup A/E/H/I/J", "2026-07-01T20:00:00.000Z", "Seattle Stadium"],
  [83, "round_of_32", "2. miejsce grupy K", "2. miejsce grupy L", "2026-07-02T23:00:00.000Z", "Toronto Stadium"],
  [84, "round_of_32", "1. miejsce grupy H", "2. miejsce grupy J", "2026-07-02T19:00:00.000Z", "Los Angeles Stadium"],
  [85, "round_of_32", "1. miejsce grupy B", "3. miejsce z grup E/F/G/I/J", "2026-07-03T03:00:00.000Z", "BC Place Vancouver"],
  [86, "round_of_32", "1. miejsce grupy J", "2. miejsce grupy H", "2026-07-03T22:00:00.000Z", "Miami Stadium"],
  [87, "round_of_32", "1. miejsce grupy K", "3. miejsce z grup D/E/I/J/L", "2026-07-04T01:30:00.000Z", "Kansas City Stadium"],
  [88, "round_of_32", "2. miejsce grupy D", "2. miejsce grupy G", "2026-07-03T18:00:00.000Z", "Dallas Stadium"],
  [89, "round_of_16", "Zwycięzca meczu 74", "Zwycięzca meczu 77", "2026-07-04T17:00:00.000Z", "Philadelphia Stadium"],
  [90, "round_of_16", "Zwycięzca meczu 73", "Zwycięzca meczu 75", "2026-07-04T21:00:00.000Z", "Houston Stadium"],
  [91, "round_of_16", "Zwycięzca meczu 76", "Zwycięzca meczu 78", "2026-07-05T20:00:00.000Z", "New York New Jersey Stadium"],
  [92, "round_of_16", "Zwycięzca meczu 79", "Zwycięzca meczu 80", "2026-07-06T00:00:00.000Z", "Mexico City Stadium"],
  [93, "round_of_16", "Zwycięzca meczu 83", "Zwycięzca meczu 84", "2026-07-06T19:00:00.000Z", "Dallas Stadium"],
  [94, "round_of_16", "Zwycięzca meczu 81", "Zwycięzca meczu 82", "2026-07-07T00:00:00.000Z", "Seattle Stadium"],
  [95, "round_of_16", "Zwycięzca meczu 86", "Zwycięzca meczu 88", "2026-07-07T16:00:00.000Z", "Atlanta Stadium"],
  [96, "round_of_16", "Zwycięzca meczu 85", "Zwycięzca meczu 87", "2026-07-07T20:00:00.000Z", "BC Place Vancouver"],
  [97, "quarterfinal", "Zwycięzca meczu 89", "Zwycięzca meczu 90", "2026-07-09T20:00:00.000Z", "Boston Stadium"],
  [98, "quarterfinal", "Zwycięzca meczu 93", "Zwycięzca meczu 94", "2026-07-10T19:00:00.000Z", "Los Angeles Stadium"],
  [99, "quarterfinal", "Zwycięzca meczu 91", "Zwycięzca meczu 92", "2026-07-11T21:00:00.000Z", "Miami Stadium"],
  [100, "quarterfinal", "Zwycięzca meczu 95", "Zwycięzca meczu 96", "2026-07-12T01:00:00.000Z", "Kansas City Stadium"],
  [101, "semifinal", "Zwycięzca meczu 97", "Zwycięzca meczu 98", "2026-07-14T19:00:00.000Z", "Dallas Stadium"],
  [102, "semifinal", "Zwycięzca meczu 99", "Zwycięzca meczu 100", "2026-07-15T19:00:00.000Z", "Atlanta Stadium"],
  [103, "third_place", "Przegrany meczu 101", "Przegrany meczu 102", "2026-07-18T21:00:00.000Z", "Miami Stadium"],
  [104, "final", "Zwycięzca meczu 101", "Zwycięzca meczu 102", "2026-07-19T19:00:00.000Z", "New York New Jersey Stadium"],
];

const groupMatches = groupStageFixtures.map(
  ([matchNo, group, homeTeam, awayTeam, kickoffAt, venue]) => ({
    matchNo,
    stage: "group",
    group,
    homeTeam,
    awayTeam,
    kickoffAt,
    venue,
  })
);

const knockoutMatches = knockoutFixtures.map(
  ([matchNo, stage, homeTeam, awayTeam, kickoffAt, venue]) => ({
    matchNo,
    stage,
    group: null,
    homeTeam,
    awayTeam,
    kickoffAt,
    venue,
  })
);

export const FIFA_WORLD_CUP_2026_MATCHES = [...groupMatches, ...knockoutMatches];
